export const init = () => {
  const observer = new MutationObserver(() => {
    if (document.querySelector('.g-labels')) {
      const labelsContainers = document.querySelectorAll('.g-labels');
      labelsContainers.forEach((item) => {
        if (item.querySelector('.more-links')) {
          const moreButton = item.querySelector('.show-more');
          moreButton.addEventListener('mouseenter', () => {
            const linksObject = item.querySelector('.more-links');
            const parrent = linksObject.offsetParent;
            const linksObjectPosition = parrent.offsetLeft + linksObject.offsetLeft;
            if (linksObjectPosition < 0) {
              linksObject.style.right = `${linksObjectPosition}px`;
            }
          })
        }
      })
    }
  })
  observer.observe(document.body, {
    childList: true,
  });
}